import { inject } from "@angular/core";
import { map } from "rxjs";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { UserService } from "./user.service";
import { AppInfoService } from "app/services/app-info.service";
import { PageConfig } from "config/page.config";



export const authGuard = (route: any, state: any) => {

//console.log (`authGuard ${route}`)

  const authService = inject(AuthService);
  const userService = inject(UserService);
  const appInfo = inject(AppInfoService);
  const router = inject(Router);
  const userUser = 'USAN User';
  const userApplicant = 'USAN Applicant';
  const userOrgAdmin = 'USAN Org Admin';
  const userNegotiator = 'USAN Negotiator';
  const userAdmin = 'USAN AMA Admin';

  if (appInfo.token) {
    if (route.routeConfig.path === "oauth/callback") {
        //console.log (`authGuard oauth/callback: ${JSON.stringify(userService.profile)}`)
        //console.log (`authGuard oauth/callback userService.profile.userRole: ${userService.profile.userRole}`)
        
        if (userService.profile.userRole) {
          if (userService.profile.userRole === userUser) {
            //TODO later sent to USAN User Dashboard
            //console.log ("userUser");
            router.navigate(['/usan/user-dashboard']);
          } else if (userService.profile.userRole === userApplicant) {
            //console.log ("userApplicant");
            router.navigate( ['/usan/applicant-dashboard'] );
          } else if (userService.profile.userRole === userOrgAdmin) {
            //console.log ("userOrgAdmin");
            router.navigate(['/usan/orgadmin-dashboard']);
          } else if (userService.profile.userRole === userNegotiator) {
            //console.log ("userNegotiator");
            router.navigate(['/usan/negotiator-dashboard']);
          } else if (userService.profile.userRole === userAdmin) {
            //console.log ("userUsanAdmin");
            router.navigate(['/usan/admin-dashboard']);
          } else {
            //console.log (`param is different ${userService.profile.userRole}`);
            router.navigate( [PageConfig.paths.usan.root] );
          }
        } else {
          if(!userService.profile.availableRoles || userService.profile.availableRoles.length < 2)  {
            //console.log (`NO param provided`);
          }
          router.navigate( [PageConfig.paths.usan.root] );
        }
        
        return false;
    } else {
        //console.log (`authGuard user: ${JSON.stringify(userService.profile)}`)
        return true;
    }
  } else {
    return authService.getLoginUrl().pipe(
      map((response: any) => {
        window.location.assign(JSON.parse(response).url);
        return false;
      })
    );
  }







};
